module.exports = __webpack_public_path__ + "static/media/coin1.fd263a6b.png";